import BaseModel from './BaseModel'
export default class Subject extends BaseModel {
  public id: string
  public code: string
  public name: string
}
